var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Copyright (C) Quantron Systems LLC.
//  All Rights Reserved.
//
//  This file is part of the private project.
//  For conditions of distribution and use,
//  please contact sales@quantron-systems.com
//
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import React, { useState, useEffect } from 'react';
import _ from 'lodash';
import { useNavigate, Link } from 'react-router-dom';
import Table from '../../components/Table';
import { stationAPI } from '../../api/stationAPI';
import { Row, Col } from '../../components/common/bootstrap';
import { Toolbar, Search } from '../../components/common';
import withConfirmation from '../../hoc/withConfirmation';
import { useAppSelector } from '../../hooks/redux';
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
function Stations(_a) {
    var doConfirmation = _a.doConfirmation;
    var _b = stationAPI.useGetStationsQuery(''), _c = _b.data, data = _c === void 0 ? [] : _c, isLoading = _b.isLoading;
    var _d = __read(stationAPI.useDeleteStationMutation(), 1), deleteStation = _d[0];
    var navigate = useNavigate();
    var _e = __read(useState(null), 2), selectedRow = _e[0], setSelectedRow = _e[1];
    var _f = __read(useState([]), 2), filteredData = _f[0], setFilteredData = _f[1];
    var search = useAppSelector(function (state) { return state.filters.search; });
    var handleEdit = function (original) {
        if (original.id) {
            navigate("/stations/".concat(original.id));
        }
    };
    var onFilterData = function () {
        var filtered = _.filter(data, function (item) {
            return _.includes(_.toLower(_.get(item, 'name')), _.toLower(search));
        });
        setFilteredData(filtered);
    };
    useEffect(function () {
        if (!_.isEmpty(data)) {
            onFilterData();
        }
    }, [data]);
    useEffect(function () {
        if (search != undefined && !_.isEmpty(data)) {
            onFilterData();
        }
    }, [search]);
    var handleDelete = function (original) {
        if (original.id) {
            doConfirmation("\u0412\u044B \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0445\u043E\u0442\u0438\u0442\u0435 \u0443\u0434\u0430\u043B\u0438\u0442\u044C \u0441\u0442\u0430\u043D\u0446\u0438\u044E ".concat(original.name, "?"), function () {
                deleteStation({ stationId: original.id });
                setSelectedRow(null);
            });
        }
    };
    var columns = React.useMemo(function () { return [
        {
            Header: 'Все станции',
            disableSortBy: true,
            columns: [
                {
                    Header: 'Станция',
                    accessor: 'name',
                    Cell: function (_a) {
                        var row = _a.row;
                        var original = row.original;
                        return _jsx(Link, __assign({ to: "/stations/".concat(original.id) }, { children: original.name }), void 0);
                    }
                },
                {
                    Header: 'Идентификатор',
                    accessor: 'id',
                    disableSortBy: true
                },
                {
                    Header: 'Владелец станции',
                    accessor: 'owner.name'
                },
                {
                    Header: 'Номер',
                    accessor: 'registryNumber'
                }
            ]
        }
    ]; }, []);
    return (_jsxs(_Fragment, { children: [_jsxs(Row, { children: [_jsx(Col, __assign({ className: 'mb-3', md: 2 }, { children: _jsx(Toolbar, { buttons: [
                                {
                                    icon: 'add',
                                    onClick: function () { return navigate('/stations/new'); },
                                    disabled: false
                                },
                                {
                                    icon: 'edit',
                                    onClick: function () { return handleEdit(selectedRow); },
                                    disabled: !selectedRow
                                },
                                {
                                    icon: 'delete',
                                    onClick: function () { return handleDelete(selectedRow); },
                                    disabled: !selectedRow
                                }
                            ] }, void 0) }), void 0), _jsx(Col, __assign({ md: 2, className: 'mb-3' }, { children: _jsx(Search, {}, void 0) }), void 0)] }, void 0), _jsx(Row, { children: _jsx(Col, { children: _jsx(Table, { columns: columns, data: filteredData, loading: isLoading, pageCount: 1000, handleSelectRow: setSelectedRow }, void 0) }, void 0) }, void 0)] }, void 0));
}
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
export default withConfirmation(Stations);
